import type { ChangeEvent } from 'react';
import { Grid } from '@mui/material';

import type { AdFieldBathsEnum, AdFieldBedsEnum } from '@/types';
import type { FilterState } from '../filterTypes';
import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface FilterOption<T> {
  label: string;
  value: T;
}

interface PropertyMetricsSectionProps {
  baths: AdFieldBathsEnum[];
  bathsOptions: FilterOption<AdFieldBathsEnum>[];
  beds: AdFieldBedsEnum[];
  bedsAndBathsVisible: boolean;
  bedsOptions: FilterOption<AdFieldBedsEnum>[];
  downPayment?: number;
  downPaymentVisible: boolean;
  onBathsChange: (value: AdFieldBathsEnum, name?: string) => void;
  onBedsChange: (value: AdFieldBedsEnum, name?: string) => void;
  onDownPaymentChange: (value: number) => void;
  onPriceChange: (
    event: ChangeEvent<HTMLInputElement>,
    name?: string,
    isQueryParams?: boolean
  ) => void;
  onSizeChange: (
    event: ChangeEvent<HTMLInputElement>,
    name?: string,
    isQueryParams?: boolean
  ) => void;
  price: FilterState['price'];
  priceTitle: string;
  size: FilterState['size'];
  sizeSubTitle: [string, string];
  sizeTitle: string;
}

export const PropertyMetricsSection = ({
  baths,
  bathsOptions,
  beds,
  bedsAndBathsVisible,
  bedsOptions,
  downPayment,
  downPaymentVisible,
  onBathsChange,
  onBedsChange,
  onDownPaymentChange,
  onPriceChange,
  onSizeChange,
  price,
  priceTitle,
  size,
  sizeSubTitle,
  sizeTitle,
}: PropertyMetricsSectionProps) => {
  return (
    <>
      <Grid item xs={12}>
        <FiltersBlock
          icon={<icons.Size />}
          name='size'
          secondName={['areaMin', 'areaMax']}
          type='numberInput'
          title={sizeTitle}
          activeButton={size}
          onChange={onSizeChange}
          subTitle={sizeSubTitle}
          dataQa='size'
        />
      </Grid>
      {bedsAndBathsVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Beds />}
            name='beds'
            type='button'
            size='little'
            title='Bedrooms'
            options={bedsOptions}
            activeButton={beds}
            onClick={onBedsChange}
            dataQa='beds'
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <FiltersBlock
          icon={<icons.Price />}
          name='price'
          secondName={['priceMin', 'priceMax']}
          type='numberInput'
          title={priceTitle}
          activeButton={price}
          onChange={onPriceChange}
          subTitle={['Minimum', 'Maximum']}
          dataQa='price'
        />
      </Grid>
      {downPaymentVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Price />}
            name='downPayment'
            type='input'
            title='Down payment'
            activeButton={downPayment}
            onClick={onDownPaymentChange}
            dataQa='downPayment'
          />
        </Grid>
      )}
      {bedsAndBathsVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Baths />}
            name='baths'
            type='button'
            size='little'
            title='Baths'
            options={bathsOptions}
            activeButton={baths}
            onClick={onBathsChange}
            dataQa='baths'
          />
        </Grid>
      )}
    </>
  );
};
